import SpeedDatingRandomMeeting from './container';

export default SpeedDatingRandomMeeting;



// WEBPACK FOOTER //
// ./src/routes/SpeedDatingRandomMeeting/index.js